/**
 * Types pour les utilisateurs
 */

export enum ProfilEnum {
  IDE = 'IDE',
  MEDECIN = 'médecin',
  AS = 'AS',
  SECRETAIRE = 'secrétaire',
  CADRE = 'cadre',
  ADMIN = 'admin',
}

export interface User {
  id: string;
  email: string;
  nom: string;
  prenom: string;
  profil: ProfilEnum;
  service: string | null;
  actif: boolean;
  created_at: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export interface LoginResponse extends TokenResponse {
  user: User;
}

/** Libellé d'un profil (liste des utilisateurs, fenêtre vocale). */
export const PROFIL_LABELS: Record<ProfilEnum, string> = {
  [ProfilEnum.IDE]: 'IDE',
  [ProfilEnum.MEDECIN]: 'Médecin',
  [ProfilEnum.AS]: 'Aide-Soignant',
  [ProfilEnum.SECRETAIRE]: 'Secrétaire',
  [ProfilEnum.CADRE]: 'Cadre de santé',
  [ProfilEnum.ADMIN]: 'Administrateur',
};

/** Titre affiché devant le nom du soignant : « Docteur » pour un médecin, sinon le libellé du profil (VREC1 S14). */
export function soignantTitre(profil: ProfilEnum): string {
  return profil === ProfilEnum.MEDECIN ? 'Docteur' : PROFIL_LABELS[profil];
}
